import type { Dispatch } from "redux";
import actions from "~/shared/actions/holdingsHistory";
import * as server from "~/shared/api/server";
import type { Period } from "~/utils/policies/policiesUtils";

export function loadHoldingsHistory(polisenummer: number, period: Period) {
	return (dispatch: Dispatch) => {
		dispatch(actions.holdingsHistoryRequest({ polisenummer, period }));
		return server.getHoldingsHistory(polisenummer, period).then((holdingsHistoryForPolicy) =>
			dispatch(
				actions.holdingsHistoryResponse({
					polisenummer,
					period,
					holdingsHistoryForPolicy,
				}),
			),
		);
	};
}
